import { axiosClient } from '@services/clients'

export async function createDepositLimitCapByPeriod(
  dataT,
  networkId,
  period,
  playerId,
  type,
) {
  const payload = playerId ? { ...dataT, player_id: playerId } : dataT
  const params = new URLSearchParams()
  if (type) params.set('type', type)
  const queryString = params.toString()

  const data = await axiosClient.post(
    `/deposit-limit-cap/network/${networkId}/${period}${
      queryString ? `?${queryString}` : ''
    }`,
    payload,
  )
  return data
}

export async function editDepositLimitCapByPeriod(
  dataT,
  networkId,
  period,
  currencyCode,
  playerId,
  type,
) {
  const payload = playerId ? { ...dataT, player_id: playerId } : dataT
  const params = new URLSearchParams()
  if (currencyCode) params.set('currency', currencyCode)
  if (type) params.set('type', type)
  const queryString = params.toString()

  const data = await axiosClient.patch(
    `/deposit-limit-cap/network/${networkId}/${period}${
      queryString ? `?${queryString}` : ''
    }`,
    payload,
  )
  return data
}

export async function deleteDepositLimitCapByPeriod(
  networkId,
  period,
  currencyCode,
  playerId,
  type,
) {
  const params = new URLSearchParams()
  if (currencyCode) params.set('currency', currencyCode)
  if (type) params.set('type', type)
  if (playerId) params.set('player_id', playerId)
  const queryString = params.toString()

  const { data } = await axiosClient.delete(
    `/deposit-limit-cap/network/${networkId}/${period}${
      queryString ? `?${queryString}` : ''
    }`,
  )
  return data
}

export async function getDepositLimitCaps(networkId, currencyCode, type) {
  try {
    const params = new URLSearchParams()
    if (currencyCode) params.set('currency', currencyCode)
    if (type) params.set('type', type)
    const queryString = params.toString()

    const {
      data: { result },
    } = await axiosClient(
      `/deposit-limit-cap/network/${networkId}${
        queryString ? `?${queryString}` : ''
      }`,
    )

    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}
